import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for UserMembershipStore, for use in the registry */ export const UserMembershipStoreActionTypes = [
    ActionType.FetchGroupDetailsSucceededAction,
    ActionType.FetchUserJoinedGroupsAction,
    ActionType.FetchUserJoinedGroupsFailedAction,
    ActionType.FetchUserJoinedGroupsSucceededAction
];
